import { createSelector } from 'reselect';

const resetPassword = state => state.modules.resetPassword;

export const getResetPasswordStatus = createSelector(
  resetPassword,
  state => state.resetPasswordStatus
);